<template>
  <div class="productsListSimple" :class="!products.length ? 'none' : ''">
    <template v-if="products.length">
      <p>{{ listTitle }}</p>
      <button type="button" class="btMore" v-if="to" @click="handleClick">
        {{ $t('shop.view_all_C08') }}
        <span class="icon iconMore3"></span>
      </button>
      <swiper
        :options="swiperOption"
        ref="productsListSimpleSwiper"
        class="productItem"
        :key="Number(componentKey)"
      >
        <swiper-slide v-for="(product, index) in products" :key="index">
          <product-item-simple v-bind="product"></product-item-simple>
        </swiper-slide>
      </swiper>
    </template>
    <p class="none" v-else>
      {{ listTitle }}{{ $t('shop.is_not_available_B02') }}
    </p>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import ProductItemSimple from '@/views/base/ProductItemSimple'
import { beforeSendLog } from '@/utils'

export default {
  components: {
    swiper,
    swiperSlide,
    ProductItemSimple
  },
  props: {
    listTitle: {
      type: String,
      default: ''
    },
    products: {
      type: Array,
      default: () => []
    },
    to: {
      type: String,
      default: ''
    }
  },
  watch: {
    products: {
      handler(n, o) {
        this.componentKey = !this.componentKey
      }
    }
  },
  data() {
    return {
      componentKey: true,
      swiperOption: {
        slidesPerView: 'auto',
        freeModeMomentum: false,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        spaceBetween: 10
      }
    }
  },
  computed: {
    object() {
      switch (this.$router.currentRoute.name) {
        case 'my':
          return 'Recent'
      }
    }
  },
  methods: {
    handleClick() {
      beforeSendLog(this.object)
      this.$router.push(this.to)
    }
  }
}
</script>

<style lang="scss"></style>
